/* XECAR · Menú de celular a pantalla completa */
if (!customElements.get('xe-mobile-menu')) {
  customElements.define(
    'xe-mobile-menu',
    class XeMobileMenu extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.xe-mm__toggle');
        this.overlay = this.querySelector('.xe-mm__overlay');
        this.closeBtn = this.querySelector('.xe-mm__close');
        this.onKey = this.onKey.bind(this);
        // Se mueve al <body> para que el header fijo/animado no lo recorte.
        if (this.overlay.parentElement !== document.body) document.body.appendChild(this.overlay);
        this.toggle.addEventListener('click', () => this.open());
        this.closeBtn.addEventListener('click', () => this.close());
        this.overlay.querySelectorAll('.xe-mm__link[aria-controls]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const sub = document.getElementById(btn.getAttribute('aria-controls'));
            const expanded = btn.getAttribute('aria-expanded') === 'true';
            btn.setAttribute('aria-expanded', String(!expanded));
            sub.hidden = expanded;
          });
        });
        this.overlay.addEventListener('click', (e) => {
          if (e.target.closest('a[href]')) this.close(true);
        });
      }
      open() {
        this.overlay.hidden = false;
        document.documentElement.classList.add('xe-mm-lock');
        this.toggle.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => requestAnimationFrame(() => this.overlay.classList.add('is-open')));
        document.addEventListener('keydown', this.onKey);
        setTimeout(() => this.overlay.querySelector('.xe-mm__link')?.focus({ preventScroll: true }), 350);
      }
      close(immediate) {
        this.overlay.classList.remove('is-open');
        document.documentElement.classList.remove('xe-mm-lock');
        this.toggle.setAttribute('aria-expanded', 'false');
        document.removeEventListener('keydown', this.onKey);
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const hide = () => { this.overlay.hidden = true; };
        if (immediate || reduce) hide(); else setTimeout(hide, 650);
        this.toggle.focus({ preventScroll: true });
      }
      onKey(e) {
        if (e.key === 'Escape') this.close();
        if (e.key === 'Tab') {
          const f = [...this.overlay.querySelectorAll('a[href], button')].filter((el) => el.offsetParent !== null);
          if (!f.length) return;
          const first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      }
    }
  );
}

/* Menú móvil: al pasar (o tocar) cada marca, solo su bloque toma el color de la marca */
(() => {
  const hot = (group) => {
    document.querySelectorAll('.xe-mm__group.is-hot').forEach((g) => { if (g !== group) g.classList.remove('is-hot'); });
    if (group) group.classList.add('is-hot');
  };
  const handler = (e) => {
    if (!e.target.closest || !e.target.closest('.xe-mm__overlay')) return;
    hot(e.target.closest('.xe-mm__group[data-skin]'));
  };
  document.addEventListener('pointerover', handler, { passive: true });
  document.addEventListener('focusin', handler);
  document.addEventListener('click', (e) => {
    if (e.target.closest && e.target.closest('.xe-mm__link[aria-expanded], .xe-mm__close, .xe-mm__toggle')) hot(null);
  });
})();

/* Menú móvil · Línea Hidráulica Industrial: cada marca es un acordeón que se despliega al tocarla */
(() => {
  const init = (root) => {
    root.querySelectorAll('.xe-mm__group[data-skin]').forEach((group, n) => {
      if (group.dataset.acc) return;
      const title = group.querySelector('.xe-mm__group-title');
      const list = group.querySelector('ul');
      if (!title || !list) return;
      group.dataset.acc = '1';
      const id = 'XeMMb-' + (group.dataset.skin || n);
      list.id = id;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'xe-mm__brand';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', id);
      btn.innerHTML = '<span class="xe-mm__brand-dot" aria-hidden="true"></span><span class="xe-mm__brand-name"></span><span class="xe-mm__plus" aria-hidden="true"></span>';
      btn.querySelector('.xe-mm__brand-name').textContent = title.textContent.trim();
      // El enlace a la página de la marca pasa a ser el primer ítem de la lista
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = title.getAttribute('href');
      a.className = 'xe-mm__brand-page';
      a.textContent = 'Ver página de la marca →';
      if (title.getAttribute('aria-current')) a.setAttribute('aria-current', 'page');
      li.appendChild(a);
      list.insertBefore(li, list.firstChild);
      title.replaceWith(btn);
      const current = list.querySelector('[aria-current="page"]') || location.pathname === a.getAttribute('href');
      const set = (open) => {
        btn.setAttribute('aria-expanded', String(open));
        list.hidden = !open;
        group.classList.toggle('is-open', open);
        group.classList.toggle('is-hot', open);
      };
      set(!!current);
      btn.addEventListener('click', () => {
        const open = btn.getAttribute('aria-expanded') !== 'true';
        if (open) root.querySelectorAll('.xe-mm__group.is-open').forEach((g) => { if (g !== group) g.querySelector('.xe-mm__brand')?.click(); });
        set(open);
        if (open) setTimeout(() => btn.scrollIntoView({ block: 'nearest', behavior: 'smooth' }), 60);
      });
    });
  };
  const run = () => document.querySelectorAll('.xe-mm__overlay').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  // por si el menú se mueve al <body> después
  setTimeout(run, 400);
})();
